import { render } from "./EditProduct.vue?vue&type=template&id=a719fe58&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=a719fe58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a719fe58"

export default script